export class DocumentsStore {
    
}